import React, { FC } from 'react';

import { getCampaignDaysLeft } from './ProductCampaignEndDate';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly startDate: number;
    readonly endDate: number;
};

const ProductCampaignSaleDates: FC<Props> = props => {
    const { t } = useTranslation();
    let releaseDateStr: string | null = null;
    try {
        releaseDateStr = t('dateFormat.dateWithShortMonth', { val: props.startDate });
    } catch (e) {
        if (e instanceof TypeError) {
            return null;
        }
        throw e;
    }

    const daysLeftLabel = getCampaignDaysLeft(props.endDate, t)[0];

    return (
        <p data-testid="sales-dates">
            Released {releaseDateStr} <br /> {daysLeftLabel}
        </p>
    );
};

export default ProductCampaignSaleDates;
